import { AsignacionSedeDto } from './asignacion-sede-dto';

export class AsignacionManualSedeDto {

    direccionIp: string;
    nombreDispositivo: string;
    nombreServicioTI: string;
    nombreRol: string;
    disponible: boolean;
    asignacionAcual: AsignacionSedeDto;
    asignacionEditada: AsignacionSedeDto;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/asignacion-manual-sede-dto.ts